import { motion, MotionProps } from 'motion/react';
import { ComponentProps, forwardRef, ReactNode } from 'react';
import useMeasure from 'react-use-measure';
import { twMerge } from 'tailwind-merge';

export type ResizablePanelProps = ComponentProps<'div'> & {
  children?: ReactNode;
  containerProps?: MotionProps & { className?: string };
  className?: string;
};

export const ResizablePanel = forwardRef<HTMLDivElement, ResizablePanelProps>(
  ({ containerProps = {}, children, className, ...props }, ref) => {
    const [innerRef, { height }] = useMeasure();

    const { className: containerClassName, ...motionProps } = containerProps;

    return (
      <motion.div
        animate={{ height: height || 'auto' }}
        transition={{ duration: 0.1 }}
        className={twMerge('w-full', containerClassName)}
        {...motionProps}
      >
        <div
          className={twMerge('flex w-full', className)}
          ref={elementRef => {
            innerRef(elementRef);

            if (typeof ref === 'function') {
              ref(elementRef);
            } else if (ref) {
              ref.current = elementRef;
            }
          }}
          {...props}
        >
          {children}
        </div>
      </motion.div>
    );
  },
);

ResizablePanel.displayName = 'ResizablePanel';
